import { type FC } from 'react';
import cn from 'classnames';

import { getPositionLabelByLeaguePosition } from '../lib';

import css from './styles.module.scss';

interface WinnerPositionProps {
  position: number;
  avatar: string;
  size?: 'large';
  className?: string;
  isVip?: boolean;
}

const WinnerPosition: FC<WinnerPositionProps> = ({
  position,
  avatar,
  size,
  className,
  isVip,
}) => {
  const kind = getPositionLabelByLeaguePosition(position);

  const percentegeByPosition: Record<number, string> = {
    21: '10',
    22: '20',
    23: '30',
    24: '50',
    25: '50',
    26: '100',
    27: '100',
  };

  return (
    <div className={cn('relative', className, position < 21 && 'w-5 h-5')}>
      <div
        className={cn(
          'absolute left-1/2 -translate-x-1/2',
          position === 1 || size === 'large'
            ? 'w-16 h-16 bottom-2'
            : 'w-12 h-12 bottom-3',
        )}
      >
        <div className="w-full h-full relative">
          <div
            style={{ backgroundImage: `url("${avatar}")` }}
            className="z-[1] absolute left-0 top-0 w-full h-full rounded-full bg-center bg-cover overflow-hidden"
          ></div>
          <div className={cn(css.border, css[`border--${kind}`])}></div>
          <div className={cn(css.effect, css[`effect--${kind}`])}></div>
          {isVip && (
            <div
              className={cn(
                'absolute top-0 left-[-10%] z-[5]',
                position === 1 ? 'w-[24px]' : 'w-[16px]',
              )}
            >
              <img src="/img/VIP/vip.svg" alt="" />
            </div>
          )}
        </div>
      </div>
      {position < 21 ? (
        <div className={cn(css.position, css[`position--${kind}`])}>
          {position}
        </div>
      ) : (
        <span className={cn(css.leagueRank, css[`leagueRank--${kind}`])}>
          <span>{`TOP ${percentegeByPosition[position]}%`}</span>
        </span>
      )}
    </div>
  );
};

export { WinnerPosition };
